export function detailTabEntries(selecteds) {
  return selecteds.map((element, eventKey) => {
    if (Array.isArray(element)) {
      if (element.length === 0) return null;

      return {
        element: {
          id: element[0].vesselTemplateId,
          type: 'vessel_template',
          title: element[0]?.vesselName,
          group: element,
        },
        eventKey,
      };
    }

    return element ? { element, eventKey } : null;
  }).filter(Boolean);
}

export function activeDetailTabKey(entries, activeKey) {
  return entries.some((entry) => entry.eventKey === activeKey)
    ? activeKey
    : entries[0]?.eventKey;
}
